import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, LocalStorageKey } from '../../../models/enums';
import { RestService } from '../../../services/rest/rest.service';
import { CommonService } from '../../../services/common/common.service';
import { v4 as uuidv4 } from 'uuid';
import { isNullOrUndefined } from '../../../models/utils';

@Component({
    standalone: false,
    selector: 'res-enter-security-code-modal',
    templateUrl: './enter-security-code-modal.component.html',
    styleUrls: ['./enter-security-code-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EnterSecurityCodeModalComponent extends BaseModalComponent implements OnInit {

    modalClass = 'enter-security-code-modal';
    modalAutomationId = 'enter-security-code';
    primaryButtonLabel = 'Continue';

    isBusy = false;
    userEmail: string;
    securityCode: number;
    rememberDevice: boolean;
    codeSent: boolean;
    showResendCodeMessage: boolean;
    accessTokenList: string;
    popoverErrors: {
        type: string,
        popover: boolean,
        message: string
    } = {
            type: 'error',
            popover: false,
            message: "Security Code is incorrect. \nPlease try again."
        };

    constructor(
        private modalService: BsModalService,
        private restService: RestService,
        private modalRef: BsModalRef,
        private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.userEmail = this.modalData.user.userEmail;
        if (this.commonService.getUuid(this.commonService.currentUser.loginUsername)) {
            this.rememberDevice = true;
        }
    }

    sendNewCode(): void {
        this.codeSent = true;
        this.showResendCodeMessage = true;
        this.createSession({ resendTotpCode: true });
    }

    clearErrors(): void {
        this.popoverErrors.popover = false;
    }

    onRememberDeviceChanged(): void {
        const token = this.commonService.getCacheData(LocalStorageKey.Uuid);
        if (this.rememberDevice) {
            if (token) {
                this.searchToken(true, token);
            } else {
                this.accessTokenList = this.commonService.currentUser.loginUsername + '||' + uuidv4();
            }
        } else {
            this.searchToken(false, token);
        }
    }

    searchToken(add, token): void {
        if (token) {
            const userAccessList = token.split('=');
            let found = false;

            for (let i = 0; i < userAccessList.length; i++) {
                const client = userAccessList[i].split('||');
                const user = client[0];
                let uid = client[1];

                if (user === this.commonService.currentUser.loginUsername.trim()) {
                    found = true;
                    if (!add) {
                        uid = null;
                        userAccessList[i] = '';
                    }
                    break;
                }
            }
            if (add && !found) {
                const uid = this.commonService.currentUser.loginUsername + '||' + uuidv4();
                token += token.slice(-1) === '=' ? uid.trim() : '=' + uid.trim();
                this.accessTokenList = token;
            }

            if (!add) {
                const list = userAccessList.filter(Boolean);
                this.accessTokenList = list.join(list.length === 0 ? '' : '=');
            }
        }
    }

    securityCheck(): void {
        this.popoverErrors.popover = false;
        if (this.accessTokenList !== undefined) {
            this.commonService.setCacheData(LocalStorageKey.Uuid, this.accessTokenList);
        }
        const request = { totpCode: this.securityCode, deviceID: this.rememberDevice ? this.commonService.getUuid(this.commonService.currentUser.loginUsername) : null, rememberDevice: this.rememberDevice, userDeviceID: this.commonService.currentUser.deviceId };
        this.createSession(request);
    }

    createSession(request): void {
        this.restService.post(Endpoint.realmManager_createSession, request, false).then(response => {
            if (response) {
                if (isNullOrUndefined(response.errorMessage) && response.sessionToken && !response.needSecurityCode && !this.codeSent) {
                    this.closeModal(true);
                }
                if (response.errorMessage && response.errorMessage.includes('Security Code is incorrect')) {
                    this.popoverErrors.popover = true;
                }
                if (response.errorMessage && response.errorMessage.includes('The allowed number')) {
                    this.closeModal(false);
                    this.commonService.openErrorModal('The allowed number of login attempts has been exceeded. Your account has been \ntemporarily locked. Please contact your system administrator to unlock your account.');
                }
                this.codeSent = false;
            }
        });
    }
}
